/** How one segment of the mapping table relates to the Step 3 groups. */
export enum MappingRowStatus {
    /** The row names a Step 3 group. */
    MAPPED = 'MAPPED',
    /** The row names a group that is not in Step 3. */
    UNKNOWN_GROUP = 'UNKNOWN_GROUP',
    /** The row has no group name. */
    NOT_MAPPED = 'NOT_MAPPED',
}

const normalise = (name: string) => name.trim().toLowerCase();

/**
 * Classifies one mapping row. Names match trimmed and in any case, the rule Step 3 uses to keep group names unique.
 * @param groupName The row's value in the group name column.
 * @param groupNames The Step 3 group names.
 */
export function mappingRowStatus(groupName: string | undefined, groupNames: string[]): MappingRowStatus {
    if (groupName == null || groupName.trim() === '') return MappingRowStatus.NOT_MAPPED;
    const known = new Set(groupNames.map(normalise));
    return known.has(normalise(groupName)) ? MappingRowStatus.MAPPED : MappingRowStatus.UNKNOWN_GROUP;
}
